import React from 'react';
import bem from 'utils/bem';
import FormikRadioField from 'forms/fields/RadioField/FormikRadioField';
import Text from 'components/Text';
import Model from '../../../../../model';

const { el } = bem('delivery-fields', 'pickup-delivery');

const Description = () => {
    const { openPickupInfo } = Model.modal;
    return (
        <div className={el('description')}>
            <div className={el('description-button')} onClick={openPickupInfo}>
                <Text>Схема проезда</Text>
            </div>
        </div>
    )
}

const PickUp = ({ selected }) => {

    return <>
        <div className={ el('radio-option', { 'delivery-region': true, selected }) }>
            <FormikRadioField
                name={'delivery'}
                text={ 'Самовывоз в Москве' }
                comment={ 'Офис “Ответ”, г. Москва, ул. 4-ая Тверская-Ямская, 22.\nРабочие часы: пн - пт с 10 до 18.00' }
                value={'pickup_msk'}
                html={Description}
            />
        </div>
    </>
}

export default PickUp;
